import { FaTimes, FaMapMarkerAlt, FaClock, FaUsers, FaDollarSign, FaCalendar, FaCheckCircle, FaEdit, FaTimesCircle } from 'react-icons/fa';
import React, { useContext } from 'react';
import AppContext from '../../../context/AppContext';
const PackageDetailsModal = ({ package: pkg, onClose, onEdit }) => {
    const { imageBaseUrl } = useContext(AppContext);

    if (!pkg) return null;

    const toArray = (val) => {
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') {
            try {
                const parsed = JSON.parse(val);
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const inclusions = toArray(pkg.package_inclusion);
    const exclusions = toArray(pkg.package_exclusion);
    const itinerary = toArray(pkg.package_itinerary);

    const getStatusColor = (status) => {
        const colors = { draft: '#6c757d', published: '#28A745', archived: '#DC3545' };
        return colors[status] || '#6c757d';
    };

    const getStatusLabel = (status) => {
        const labels = { draft: 'Draft', published: 'Published', archived: 'Archived' };
        return labels[status] || status;
    };

    return (
        <div className="adm-pkg-modal-overlay" onClick={onClose}>
            <div className="adm-pkg-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="adm-pkg-modal-header">
                    <h2>Package Details</h2>
                    <button className="adm-pkg-modal-close" onClick={onClose}><FaTimes /></button>
                </div>

                <div className="adm-pkg-modal-body">
                    <div className="adm-pkg-modal-image">
                        <img
                            src={
                                pkg.package_image
                                ? `${imageBaseUrl}/${pkg.package_image.replace(/^\/?storage\//, "")}`
                                : "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600"
                                }
                            onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600'; }}
                        />
                        <div className="adm-pkg-modal-badges">
                            <span className="adm-pkg-modal-badge-status" style={{ backgroundColor: getStatusColor(pkg.package_status) }}>
                                {getStatusLabel(pkg.package_status)}
                            </span>
                            <span className={`adm-pkg-modal-avail-badge ${pkg.is_available ? 'adm-pkg-modal-avail-yes' : 'adm-pkg-modal-avail-no'}`}>
                                {pkg.is_available ? 'Available' : 'Unavailable'}
                            </span>
                        </div>
                    </div>

                    <div className="adm-pkg-modal-title">
                        <h3>{pkg.package_name}</h3>
                        {pkg.package_category && <span className="adm-pkg-modal-category-tag">{pkg.package_category}</span>}
                    </div>

                    <div className="adm-pkg-modal-quick-info">
                        <div className="adm-pkg-modal-info-item">
                            <FaMapMarkerAlt className="adm-pkg-modal-icon" />
                            <div><label>Destination</label><p>{pkg.package_destination || '—'}</p></div>
                        </div>
                        <div className="adm-pkg-modal-info-item">
                            <FaMapMarkerAlt className="adm-pkg-modal-icon" />
                            <div><label>Location</label><p>{pkg.location || '—'}</p></div>
                        </div>
                        <div className="adm-pkg-modal-info-item">
                            <FaClock className="adm-pkg-modal-icon" />
                            <div><label>Duration</label><p>{pkg.duration_days || 0}D / {pkg.duration_nights || 0}N</p></div>
                        </div>
                        <div className="adm-pkg-modal-info-item">
                            <FaUsers className="adm-pkg-modal-icon" />
                            <div><label>Max People</label><p>{pkg.max_people_size || '—'} persons</p></div>
                        </div>
                        <div className="adm-pkg-modal-info-item">
                            <FaDollarSign className="adm-pkg-modal-icon" />
                            <div><label>Price</label><p>PKR {Number(pkg.package_price)?.toLocaleString() || '0'}</p></div>
                        </div>
                        <div className="adm-pkg-modal-info-item">
                            <FaCalendar className="adm-pkg-modal-icon" />
                            <div><label>Added On</label><p>{pkg.created_at ? new Date(pkg.created_at).toLocaleDateString() : '—'}</p></div>
                        </div>
                    </div>

                    {pkg.package_description && (
                        <div className="adm-pkg-modal-section">
                            <h4>Description</h4>
                            <p className="adm-pkg-modal-description">{pkg.package_description}</p>
                        </div>
                    )}

                    {inclusions.length > 0 && (
                        <div className="adm-pkg-modal-section">
                            <h4>Inclusions</h4>
                            <div className="adm-pkg-modal-inclusions">
                                {inclusions.map((item, index) => (
                                    <div key={index} className="adm-pkg-inclusion-item">
                                        <FaCheckCircle className="adm-pkg-check-icon" />
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {exclusions.length > 0 && (
                        <div className="adm-pkg-modal-section">
                            <h4>Exclusions</h4>
                            <div className="adm-pkg-modal-inclusions">
                                {exclusions.map((item, index) => (
                                    <div key={index} className="adm-pkg-inclusion-item adm-pkg-exclusion-item">
                                        <FaTimesCircle className="adm-pkg-times-icon" />
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {itinerary.length > 0 && (
                        <div className="adm-pkg-modal-section">
                            <h4>Itinerary</h4>
                            <div className="adm-pkg-itinerary-display">
                                {itinerary.map((day, index) => (
                                    <div key={index} className="adm-pkg-itinerary-day-display">
                                        <div className="adm-pkg-itinerary-day-num">Day {day.day || index + 1}</div>
                                        <div className="adm-pkg-itinerary-day-content">
                                            <h5>{day.title}</h5>
                                            <p>{day.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="adm-pkg-modal-footer">
                    <button className="adm-pkg-modal-btn-secondary" onClick={onClose}>Close</button>
                    <button className="adm-pkg-modal-btn-primary" onClick={() => { onEdit(pkg); onClose(); }}>
                        <FaEdit /> Edit Package
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PackageDetailsModal;